import React from 'react';
import { connect } from 'react-redux';
import { X, Play, Pause } from 'phosphor-react';

const QuestionContent = ({
  localizations,
  quiz,
  currentState,
  userAnswers,
  goReportAction,
  nextQuestionAction,
  xButtonAction,
  tabItemClickAction,
  choiceSelectAction,
  onPlayClick,
  onPauseClick,
  isPlaying,
  currentAudioId,
}) => {
  const buildButton = () => {
    if (quiz?.questions.length > 0) {
      const maxOrder = Math.max(...quiz.questions.map((q) => q.questionOrder));
      if (currentState.question?.questionOrder === maxOrder) {
        return (
          <div className="close-btn" aria-hidden onClick={goReportAction}>
            Sonucu Göster
          </div>
        );
      }

      return (
        <div className="close-btn" aria-hidden onClick={nextQuestionAction}>
          Sonraki Soru
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <div className="quiz-modal-close">
        <button
          aria-hidden={true}
          className="close"
          onClick={xButtonAction}
          type="button"
        >
          <X color="red" size={40} />
        </button>
      </div>

      <div className="quiz-modal-title">
        {quiz?.type
          ? `${localizations?.QUIZ ?? 'Değerlendirme'} - ${
              localizations[quiz?.type] ?? quiz?.type
            }`
          : localizations?.QUIZ ?? 'Değerlendirme'}
      </div>

      <div className="quiz-modal-tabs">
        {quiz?.questions
          ?.sort((a, b) => a.questionOrder - b.questionOrder)
          ?.map((question) => {
            const tabItemClassNames = ['quiz-modal-tab-item'];
            if (question.id === currentState.questionId) {
              tabItemClassNames.push('active');
            } else if (userAnswers[question.id]?.userAnswerId !== null) {
              tabItemClassNames.push('has-answer');
            }
            return (
              <div
                key={question.id}
                className={tabItemClassNames.join(' ')}
                aria-hidden
                onClick={() => tabItemClickAction(question.id)}
              >
                <p>{question.questionOrder}</p>
              </div>
            );
          })}
      </div>

      {currentState.question !== null ? (
        <div className="quiz-modal-question-wrapper">
          <div className="quiz-modal-question-container">
            {currentState.question.audioUrl &&
            currentState.question.audioUrl !== '' ? (
              <>
                {!isPlaying ||
                currentAudioId !== `Question-${currentState.question.id}` ? (
                  <div
                    className="quiz-modal-play-btn"
                    aria-hidden
                    onClick={(event) => {
                      event.preventDefault();
                      onPlayClick(
                        `Question-${currentState.question.id}`,
                        currentState.question.audioUrl
                      );
                    }}
                  >
                    <Play color="#67BCEC" size={30} weight="duotone" />
                  </div>
                ) : (
                  <div
                    className="quiz-modal-play-btn"
                    aria-hidden
                    onClick={() =>
                      onPauseClick(`Question-${currentState.question?.id}`)
                    }
                  >
                    <Pause color="#67BCEC" size={30} weight="duotone" />
                  </div>
                )}
              </>
            ) : null}
            <div className="quiz-modal-text-container">
              <div className="quiz-modal-question-title">
                <p>{`${localizations?.QUESTION ?? 'Soru'} ${
                  currentState.question.questionOrder
                }`}</p>
              </div>
              <p className="quiz-modal-question-text">
                {currentState.question.text}
              </p>
            </div>
            {currentState.question.imageUrl &&
            currentState.question.imageUrl !== '' ? (
              <div className="quiz-modal-question-image">
                <img
                  src={currentState.question.imageUrl}
                  alt={currentState.question.text}
                />
              </div>
            ) : null}
          </div>
          {currentState.question.choices &&
          currentState.question.choices.length > 0 ? (
            <div className="quiz-modal-question-choices">
              {currentState.question.choices
                .sort((a, b) => a.choiceOrder - b.choiceOrder)
                .map((ch, i) => {
                  const itemClassNames = ['quiz-modal-question-choice-item'];
                  if (
                    userAnswers &&
                    userAnswers[currentState.question.id]?.userAnswerId ===
                      ch.id
                  ) {
                    itemClassNames.push('marked-choice');
                  }

                  if (
                    (!ch.text || ch.text === '') &&
                    ch.imageUrl &&
                    ch.imageUrl !== ''
                  ) {
                    itemClassNames.push('only-image');
                  }

                  return (
                    <div
                      key={ch.id}
                      className={itemClassNames.join(' ')}
                      onClick={() => choiceSelectAction(ch.id)}
                    >
                      <div className="quiz-modal-choice-item-char">
                        {['A', 'B', 'C', 'D'][i]}
                      </div>
                      {ch.audioUrl && ch.audioUrl !== '' ? (
                        <>
                          {!isPlaying ||
                          currentAudioId !== `Choice-${ch.id}` ? (
                            <div
                              className="quiz-modal-play-btn"
                              aria-hidden
                              onClick={(event) => {
                                event.preventDefault();
                                onPlayClick(`Choice-${ch.id}`, ch.audioUrl);
                              }}
                            >
                              <Play
                                color="#67BCEC"
                                size={30}
                                weight="duotone"
                              />
                            </div>
                          ) : (
                            <div
                              className="quiz-modal-play-btn"
                              aria-hidden
                              onClick={() => onPauseClick(`Choice-${ch.id}`)}
                            >
                              <Pause
                                color="#67BCEC"
                                size={30}
                                weight="duotone"
                              />
                            </div>
                          )}
                        </>
                      ) : null}
                      {ch.text && ch.text !== '' ? (
                        <div className="quiz-modal-choice-item-text">
                          {ch.text}
                        </div>
                      ) : null}
                      {ch.imageUrl && ch.imageUrl !== '' ? (
                        <div className="quiz-modal-choice-item-image">
                          <img
                            src={ch.imageUrl}
                            alt={['A', 'B', 'C', 'D'][i]}
                          />
                        </div>
                      ) : null}
                    </div>
                  );
                })}
            </div>
          ) : null}

          <div className="quiz-modal-close">{buildButton()}</div>
        </div>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  quiz: state.data.quiz,
  localizations: state.localization?.pairs,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionContent);
